import styled from "styled-components";
import { Badge, palette } from "@conserveit/blocks";
import {
  BASE_UNIT,
  SPACING,
  LAYERS,
  OPACITY,
} from "../../components/AppChrome/App.constants";
import { $ButtonItem, $Menu } from "../../components/Menu/Menu.styles";

export const $Wrapper = styled.div`
  position: relative;
  padding-top: 4px;
`;

function showCount({ count }) {
  return count > 0 ? "inherit" : "none";
}

export const $IconBubble = styled(Badge)`
  display: ${showCount};
  position: absolute;
  top: 2px;
  left: 50%;
  min-width: ${BASE_UNIT * 3}px;
  background: ${palette.orange5};
  height: ${BASE_UNIT * 2}px;
  z-index: ${LAYERS.FIRST};
`;

export const $Label = styled.button.attrs({ type: "button" })`
  display: inline-flex;
  align-items: center;
  border: none;
  font-size: 14px;
  background: none;

  &:focus {
    outline: 0;
  }
`;

function showList({ isOpen }) {
  return isOpen ? "block" : "none";
}
export const $List = styled($Menu)`
  display: ${showList};
  left: auto;
  right: 0;
`;

export const $Setting = styled($ButtonItem)`
  span {
    margin-right: ${SPACING.TIGHT};
  }

  &:disabled {
    opacity: ${OPACITY.SUBDUED};

    span {
      cursor: default;
    }
  }
`;
